<template>
  <div v-if="record" class="record_detail">
    <record-panel :record="record" />
  </div>
</template>

<script>
import RecordPanel from './components/RecordPanel'
import { recordInfo } from '@/api/record'

export default {
  name: 'RecordDetail',
  components: {
    RecordPanel
  },
  data () {
    return {
      record: null
    }
  },
  created () {
    let recordId = this.$route.params.record_id || ''
    this.getRecordInfo(recordId)
  },
  methods: {
    async getRecordInfo (recordId) {
      let response = await recordInfo(recordId)
      this.record = response.data
    }
  }
}
</script>

<style scoped lang="scss">
</style>
